// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://ctapi.dev.capium.co.uk/',
  uiUrl: 'https://ct.dev.capium.co.uk/',
  appDomain: 'ct.dev',
  stsServerUrl: 'https://account.dev.capium.co.uk',
  identityLoginUrl: 'https://account.dev.capium.co.uk/Account/Login',
  clientId: 'capium_timeandfee_angular',
  apiVersionUrl: 'https://ctapi.dev.capium.co.uk/api/v1/',
  //apiVersionUrl: 'http://localhost:47174/api/v1/',
  //apiVersionUrl_V2: 'http://localhost:47174/api/v2/',
  helpDeskUrl: 'https://capium.freshdesk.com/support/home',
  subscriptionApiUrl: 'https://storeapi.dev.capium.co.uk/api/v1',
  
};
